import { useFormik } from 'formik';
import { initialValues, validationSchema } from './formData';
import { cleanObj } from '../../../../../../shared/utils/objects';
import { ISelect, ParamEnum } from '../../../../../../shared/types/shared';
import { useEffect, useState } from 'react';
import { asyncGetParams } from '../../../../../../services/param.service';
import { AlertsProcessProps } from './props';
import { AlertsProcess } from '../../../../../../shared/types/legalProceedings/alerts';

export const useAlertsStatus = ({
    data,
    onChangeData,
    onChangeFormik,
}: AlertsProcessProps) => {
    const [typesStatus, setTypesStatus] = useState<ISelect[]>([]);
    const [typesReceptionChanel, setTypesReceptionChanel] = useState<ISelect[]>(
        []
    );
    const [typesPQR, setTypesPQR] = useState<ISelect[]>([]);
    const [typesReceivedThrough, setTypesReceivedThrough] = useState<ISelect[]>(
        []
    );
    const [typesSubtypeDP, setTypesSubtypeDP] = useState<ISelect[]>([]);
    const [typesTransaction, setTypesTransaction] = useState<ISelect[]>([]);

    const onSubmit = (data: AlertsProcess) => {
        if (onChangeData) onChangeData(cleanObj(data) || {});
    };

    const formik = useFormik({
        initialValues,
        validationSchema,
        onSubmit,
    });

    useEffect(() => {
        if (onChangeFormik) onChangeFormik(formik);
    }, [formik.values, formik.errors]);

    useEffect(() => {
        formik?.setFieldValue('receptionChannel', data?.receptionChannel || '');
        formik?.setFieldValue('typePQR', data?.typePQR || '');
        formik?.setFieldValue('receivedThrough', data?.receivedThrough || '');
        formik?.setFieldValue('subtypeDP', data?.subtypeDP || '');
        formik?.setFieldValue('transaction', data?.transaction || '');
    }, [data]);

    useEffect(() => {
        if (Boolean(formik.values.typePQR)) {
            asyncGetParams(
                ParamEnum.PQR_HALF,
                undefined,
                formik.values.typePQR
            ).then((items) => {
                setTypesReceivedThrough(items);
            });
        }
    }, [formik.values.typePQR, typesPQR]);

    useEffect(() => {
        if (Boolean(formik.values.receivedThrough)) {
            asyncGetParams(
                ParamEnum.PQR_SUBTYPE_DP,
                undefined,
                formik.values.receivedThrough
            ).then((items) => setTypesSubtypeDP(items));
        }
    }, [formik.values.receivedThrough]);

    useEffect(() => {
        asyncGetParams(ParamEnum.PQR_STATUS).then((params) =>
            setTypesStatus(params)
        );
        asyncGetParams(ParamEnum.PQR_RECEPTION_CHANNEL).then((params) =>
            setTypesReceptionChanel(params)
        );
        asyncGetParams(ParamEnum.PQR_TYPE).then((params) =>
            setTypesPQR(params)
        );
        asyncGetParams(ParamEnum.PQR_PROCEDURE).then((params) =>
            setTypesTransaction(params)
        );
    }, []);

    return {
        formik,
        typesStatus,
        typesReceptionChanel,
        typesPQR,
        typesReceivedThrough,
        typesSubtypeDP,
        typesTransaction,
    };
};
